let keyCloakUrl = ""

if (import.meta.env.MODE && import.meta.env.MODE === "development") {
	// dev code
	keyCloakUrl = "http://localhost:8085/auth/realms/WSFR";
} else {
    
    if (window.location.host.includes("bstack")) {
        // release candidate
        keyCloakUrl = window.location.protocol + "//" + window.location.host + "/auth/realms/WSFR";
    } else if (window.location.host.includes("worldskills-france")) {
        // production code
        keyCloakUrl = "https://auth.worldskills-france.org/auth/realms/WSFR";
    } else {
        // default code
        keyCloakUrl = window.location.protocol + "//" + window.location.host + "/auth/realms/WSFR";
    }
	
}



const onSigninCallback = () => {
    window.history.replaceState(
        {},
        document.title,
        window.location.pathname
    )
}


export const oidcConfig = {
    authority: keyCloakUrl,
    client_id: "forum-front",
    redirect_uri: window.location.origin + "/?redirect_uri=" + window.location.pathname + window.location.search,
    post_logout_redirect_uri: window.location.origin + "/login?noAuto=true",
    onSigninCallback: onSigninCallback,
};